import { selectors } from '../../state';
import { ITEM_STATUSES } from '../../constants';

export const itemStatusesByKind = state => {
  const move = selectors.current.move(state);

  return selectors.item
    .allByMoveId(move.id(state), state)
    .reduce((items, item) => {
      const kind = item.kind(state);

      return {
        ...items,
        ...{
          [kind]: (items[kind] || []).concat({
            status: item.status(state),
            statusUpdatedAt: item.statusUpdatedAt(state),
          }),
        },
      };
    }, {});
};

export const statusFromItems = (items = []) => {
  return items
    .sort(({ statusUpdatedAt: a }, { statusUpdatedAt: b }) => (a > b ? 1 : -1))
    .map(item => ({
      ...item,
      status:
        item.status === ITEM_STATUSES.VALIDATING
          ? ITEM_STATUSES.PENDING
          : item.status,
    }))
    .reduce((result, { status, statusUpdatedAt }) => {
      if (
        status === ITEM_STATUSES.PENDING ||
        (status === ITEM_STATUSES.COMPLETED &&
          result.status !== ITEM_STATUSES.PENDING) ||
        [ITEM_STATUSES.PENDING, ITEM_STATUSES.COMPLETED].indexOf(
          result.status
        ) === -1
      ) {
        return { status, statusUpdatedAt };
      }

      return result;
    }, {});
};
